// PARAQTA — "Дауыс" мақалалар бөлімі (рецензия / рефлексия / эссе).
// Кэш `_dawysData` module-ішінде ғана сақталады.
// Step F5: Modal Medium-style + Esc handler + drag-to-close (mobile only).

import { api } from '../../core/api.js';
import { esc } from '../../utils/format.js';
import { coverGradient } from '../../utils/covers.js';
import { DAWYS_CAT, DAWYS_CAT_CLS } from '../../constants/achievements.js';

let _dawysData = null;

// Modal session state — open/close арасында cleanup үшін.
let _modalEscHandler = null;
let _modalDragCleanup = null;
let _savedScrollY = 0;

// iOS-style scroll lock: body fixed + top -savedY,
// unlock-та scrollTo restore жасайды (бір орнымен қайтады).
function lockScroll() {
  _savedScrollY = window.scrollY;
  document.body.style.top = `-${_savedScrollY}px`;
  document.body.classList.add('modal-open');
}

function unlockScroll() {
  document.body.classList.remove('modal-open');
  document.body.style.top = '';
  window.scrollTo(0, _savedScrollY);
}

// Cache getter — dashboard `if (!_dawysData) loadDawysSection()` шарты үшін.
export function hasDawysData() { return !!_dawysData; }

function dawysCard(a) {
  const catLabel = DAWYS_CAT[a.category] || a.category;
  const catCls = DAWYS_CAT_CLS[a.category] || 'review';
  const coverInner = a.cover_url
    ? '<img src="' + esc(a.cover_url) + '" loading="lazy" alt="">'
    : '<div class="' + coverGradient(a.book_title, a.book_author) + '" style="position:absolute;inset:0"></div>';
  return '<div class="dcard" data-action="open-dawys" data-id="' + a.id + '">' +
    '<div class="dcard-cov" style="position:relative">' + coverInner + '</div>' +
    '<div class="dcard-body">' +
    '<span class="dcard-badge ' + catCls + '">' + catLabel + '</span>' +
    '<div class="dcard-title">' + esc(a.title) + '</div>' +
    '<div class="dcard-book">' + esc(a.book_title || '') + (a.book_author ? ' · ' + esc(a.book_author) : '') + '</div>' +
    '<div class="dcard-footer"><span>' + esc(a.author_name || 'Оқырман') + '</span><span>' + (a.read_time_minutes || 3) + ' мин</span></div>' +
    '</div></div>';
}

export async function loadDawysSection() {
  const d = await api('/api/dawys?limit=10');
  _dawysData = d;
  if (!d || !d.items || !d.items.length) return;
  const html = d.items.map(dawysCard).join('');
  // Landing
  const ls = document.getElementById('landDawysSec');
  const lscroll = document.getElementById('landDawysScroll');
  if (ls && lscroll) { lscroll.innerHTML = html; ls.style.display = ''; }
  // Dashboard
  const ds = document.getElementById('dashDawysSec');
  const dscroll = document.getElementById('dashDawysScroll');
  if (ds && dscroll) { dscroll.innerHTML = html; ds.style.display = ''; }
}

export async function loadDawysPage() {
  const grid = document.getElementById('dawysPageGrid');
  if (!grid) return;
  if (_dawysData && _dawysData.items) {
    grid.innerHTML = _dawysData.items.map(dawysCard).join('');
    return;
  }
  grid.innerHTML = '<div class="loading"><span class="spinner"></span>Жүктелуде...</div>';
  const d = await api('/api/dawys?limit=50');
  if (!d || !d.items || !d.items.length) {
    grid.innerHTML = '<p style="color:var(--ink4);padding:20px">Мақалалар жоқ</p>';
    return;
  }
  _dawysData = d;
  grid.innerHTML = d.items.map(dawysCard).join('');
}

export async function openDawysArticle(id) {
  const ov = document.getElementById('dawysModal');
  const content = document.getElementById('dawysModalContent');
  if (!ov || !content) return;

  // Step N4.5 — Bug fix #2: Race condition.
  // Modal animation кезінде (~350ms) body position:fixed орнатылады,
  // карточка орны жылжиды. Пайдаланушының тырнағы кездейсоқ bottom nav
  // батырмасына тиіп қалуы мүмкін. Animation біткенше nav-тар disable.
  const appNav = document.getElementById('appNav');
  const bnav = document.getElementById('bnav');
  if (appNav) appNav.style.pointerEvents = 'none';
  if (bnav)   bnav.style.pointerEvents = 'none';
  setTimeout(() => {
    if (appNav) appNav.style.pointerEvents = '';
    if (bnav)   bnav.style.pointerEvents = '';
  }, 350);

  // Step N4.5 — Bug fix #1: Flash.
  // Бұрын: lockScroll() body.top = -savedY бірден set жасайтын →
  // body jumping modal animation параллельмен жанжалы → flash.
  // Қазір: open class бірінші, lockScroll келесі rendering frame-де
  // (animation паrallель — flash сезілмейді).
  ov.classList.add('open');
  requestAnimationFrame(() => lockScroll());

  content.innerHTML = '<div class="loading" style="padding:60px;text-align:center"><span class="spinner"></span></div>';
  const a = await api('/api/dawys/' + id);
  if (!a) { content.innerHTML = '<p style="padding:24px">Қате болды</p>'; return; }
  const catLabel = DAWYS_CAT[a.category] || '';
  const catCls = DAWYS_CAT_CLS[a.category] || 'review';
  const coverHtml = a.cover_url
    ? '<img src="' + esc(a.cover_url) + '" alt="" style="width:100%;height:100%;object-fit:cover">'
    : '';
  const dateStr = a.created_at ? a.created_at.slice(0, 10) : '';
  // Step N5: "Кітап туралы" CTA — book_slug бар болса ғана.
  // Click → article modal smooth жабылу + 320ms кейін openBookPage(slug).
  const bookCtaHtml = (a.book_slug && a.book_title)
    ? '<div class="dawys-modal-book-cta">' +
        '<div class="dawys-modal-book-line">📖 ' + esc(a.book_title) +
          (a.book_author ? ' — ' + esc(a.book_author) : '') + '</div>' +
        '<button class="dawys-modal-book-btn" data-action="open-book-from-modal" data-slug="' + esc(a.book_slug) + '">' +
          'Кітап туралы →' +
        '</button>' +
      '</div>'
    : '';

  content.innerHTML =
    '<div class="dawys-modal-handle"></div>' +
    '<div class="dawys-modal-head">' +
    '<button class="dawys-modal-close" data-action="close-dawys">✕</button>' +
    '<div style="display:flex;gap:14px;align-items:flex-start">' +
    '<div class="dawys-modal-cover">' + coverHtml + '</div>' +
    '<div><div style="font-size:.7rem;color:var(--ink3)">' + esc(a.book_title || '') + (a.book_author ? ' — ' + esc(a.book_author) : '') + '</div>' +
    '<span class="dcard-badge ' + catCls + '" style="margin-top:6px">' + catLabel + '</span></div>' +
    '</div>' +
    '<div class="dawys-modal-htitle">' + esc(a.title) + '</div>' +
    (a.subtitle ? '<div style="font-size:.82rem;color:var(--ink3);margin-bottom:12px;font-style:italic">' + esc(a.subtitle) + '</div>' : '') +
    '<div class="dawys-modal-meta">' +
    '<span>✍ ' + esc(a.author_name || 'Оқырман') + '</span>' +
    '<span>⏱ ' + (a.read_time_minutes || 3) + ' мин</span>' +
    '<span>👁 ' + (a.views || 0) + ' көрілді</span>' +
    (dateStr ? '<span>' + dateStr + '</span>' : '') +
    '</div></div>' +
    '<div class="dawys-modal-content">' + esc(a.content || '') + bookCtaHtml + '</div>';

  // Esc → жабу
  _modalEscHandler = (e) => { if (e.key === 'Escape') closeDawysModal(); };
  document.addEventListener('keydown', _modalEscHandler);

  // Drag-to-close (тек mobile/touch device)
  _modalDragCleanup = enableDragToClose();
}

export function closeDawysModal() {
  const ov = document.getElementById('dawysModal');
  const box = document.getElementById('dawysModalBox');

  // Drag-нің inline стильдерін кетіру — болашақ CSS class transition
  // (translateY(100%) mobile / translateY(20px) desktop) дұрыс шығу үшін.
  // Inline transform/background drag кезінде set жасалған еді.
  if (box) {
    box.style.transition = '';
    box.style.transform = '';
  }
  if (ov) ov.style.background = '';

  // CSS-те `.dawys-modal-ov.open` removed → opacity 0 + slide-out
  // transition (320ms mobile / 300ms desktop) ауысады.
  if (ov) ov.classList.remove('open');

  // Esc handler жою
  if (_modalEscHandler) {
    document.removeEventListener('keydown', _modalEscHandler);
    _modalEscHandler = null;
  }

  // Drag listener-лерды cleanup
  if (_modalDragCleanup) {
    _modalDragCleanup();
    _modalDragCleanup = null;
  }

  // Animation бітерден кейін scroll restore (320ms — mobile bottom-sheet)
  setTimeout(unlockScroll, 320);
}

// ── Drag-to-close (Apple Maps стилі bottom-sheet) ──
// Тек touch device-те жұмыс істейді. Modal жабылғанда listener-лер тазаланады.
function enableDragToClose() {
  if (!('ontouchstart' in window)) return null;

  const box = document.getElementById('dawysModalBox');
  const ov = document.getElementById('dawysModal');
  const content = document.getElementById('dawysModalContent');
  if (!box || !ov || !content) return null;

  let startY = 0;
  let currentY = 0;
  let isDragging = false;

  const onStart = (e) => {
    // Тек жоғарғы жақта (content scrollTop = 0) — modal ішкі scroll
    // болса drag жасамаймыз.
    if (content.scrollTop > 0) return;
    startY = e.touches[0].clientY;
    currentY = startY;
    isDragging = true;
    box.style.transition = 'none';
  };

  const onMove = (e) => {
    if (!isDragging) return;
    currentY = e.touches[0].clientY;
    const delta = currentY - startY;
    if (delta > 0) {
      // Step N3: артындағы Феед scroll-ды бұғаттау.
      e.preventDefault();
      box.style.transform = `translateY(${delta}px)`;
      // Backdrop opacity сабырлы азаяды (60% → 20%).
      const opacity = Math.max(0.6 - delta / 800, 0.2);
      ov.style.background = `rgba(28,26,22,${opacity})`;
    }
  };

  const onEnd = () => {
    if (!isDragging) return;
    isDragging = false;
    const delta = currentY - startY;
    if (delta > 100) {
      // closeDawysModal() inline стильдерді кетіреді → CSS class
      // transition (translateY(100%) mobile) дұрыс animation береді.
      closeDawysModal();
    } else {
      // Snap back — inline transform жоямын, transition қайтады.
      box.style.transition = '';
      box.style.transform = '';
      ov.style.background = '';
    }
  };

  // Step N3: passive: false — preventDefault жұмыс жасау үшін міндетті.
  box.addEventListener('touchstart', onStart, { passive: true });
  box.addEventListener('touchmove', onMove, { passive: false });
  box.addEventListener('touchend', onEnd);

  return () => {
    box.removeEventListener('touchstart', onStart);
    box.removeEventListener('touchmove', onMove);
    box.removeEventListener('touchend', onEnd);
  };
}
